import { render, staticRenderFns } from "./ArabicContract.vue?vue&type=template&id=6a05f1ca&scoped=true&"
import script from "./ArabicContract.vue?vue&type=script&lang=js&"
export * from "./ArabicContract.vue?vue&type=script&lang=js&"
import style0 from "./ArabicContract.vue?vue&type=style&index=0&id=6a05f1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a05f1ca",
  null
  
)

export default component.exports